module.exports = __webpack_public_path__ + "img/logodarkcolor.6b77a462.png";